<nz-alert nzType="error" [nzMessage]="unauth"></nz-alert>
<ng-template #unauth>
  <strong>Unauthorized Access.</strong> Please <a routerLink="/login">login again</a> if you are resident.
</ng-template>
